export default __webpack_public_path__ + "/img/dep01.0f540dcb.jpg";